import { render, staticRenderFns } from "./FontSizeButton.vue?vue&type=template&id=0cef60b4&lang=pug&"
import script from "./FontSizeButton.vue?vue&type=script&lang=js&"
export * from "./FontSizeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports